<template>
<div id="adduser" v-cloak>

    <div v-if="isBusy" class="text-center"> <p> <b-spinner></b-spinner> </p>  </div>

    <div v-if="!isBusy && !dataError" class="pl-2 pr-2">

            <b-form-group label-cols-sm="2" label="Search">
          <b-input-group>
            <b-form-input v-model="filter" autofocus placeholder="Type name to search"></b-form-input>
            <b-input-group-append>
              <b-button class="ml-1" :disabled="!filter" @click="filter = ''">&#10008; Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
    
    <div id="potable">
    <b-table v-show="filtered"
        small hover :items="data" :fields="fields" :filter="filter" 
        selectable select-mode="single" @row-selected="onSelected"
        @filtered="onFiltered" :per-page="perPage" :current-page="currentPage"
        >

    </b-table> </div>

    <b-pagination  
      v-show="totalRows>perPage&&filtered"
      v-model="currentPage"
      align="center"
      :total-rows="totalRows"
      :per-page="perPage"
      aria-controls="potable"
      hide-ellipsis>
    </b-pagination>
    
    </div>

    <div v-if="dataError">
      <p><b-alert show variant="danger">An error occurred loading data.</b-alert></p>
      <p>{{ error }}</p>
    </div>

   
</div>    
</template>

<script>
export default {
  name: "AddUser",
  props: {},
  components: {},

  data: function(){
      return{
          data: [],
          selected: null,
          projectId: this.$route.params.id, 
          isBusy: true,
          dataError: false,
          error: "",
          fields: ['userId', 'name'],
          filter: "",
          totalRows: 0,
          currentPage: 1,
          perPage: 12

      }
  },

  computed: {
    filtered: function(){
      return (this.filter.length>0);
    } 
  },

  methods: {
    
     fetchData() {
      this.$auth.acquireToken().then(token => {
        this.$http
          .get("api/UserList", {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            this.data = response.data;
            this.totalRows = this.data.length;
            this.dataRows = this.data.length;
          })
          .catch(error => {
            this.dataError = true;
            if (error.response) {this.error = error.response.statusText};
          })
          .finally(() => (this.isBusy = false));
      });
    },

     onSelected(item) {
        this.selected = item[0];
        var newUser = {projectId:this.projectId, userId:this.selected.userId, userName:this.selected.name, modules:'journal,poviewer,photos,issuelog' };
        this.$emit('addUser', newUser);
      },

     onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },      

  },

activated: function() {
    
  },

  mounted: function(){
      this.isBusy = true;
      this.fetchData();
  }
    
}
</script>

<style scoped>

#adduser {
  max-width: 500px;
  margin: 0 auto;
  padding-top: 5px;
}

</style>